var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcasts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.695,
    height: 14.382,
    viewBox: "0 0 12.695 14.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M343.767,53.75V47.29a1.047,1.047,0,1,1,1.01.076V53.75a.511.511,0,0,1-.509.509A.5.5,0,0,1,343.767,53.75Zm3.116-5.271a.5.5,0,0,0,.7-.17,3.68,3.68,0,0,0,.535-2.088,3.75,3.75,0,0,0-3.888-3.582,3.743,3.743,0,0,0-3.566,3.888,3.749,3.749,0,0,0,.458,1.655.506.506,0,0,0,.7.2.513.513,0,0,0,.2-.7,2.819,2.819,0,0,1-.34-1.205,2.756,2.756,0,0,1,.713-1.952,2.728,2.728,0,0,1,4.72,1.74,2.664,2.664,0,0,1-.391,1.519A.509.509,0,0,0,346.883,48.479Zm1.494,1.961a.52.52,0,0,0,.722-.059,6.2,6.2,0,1,0-9.313.17.511.511,0,0,0,.374.17.482.482,0,0,0,.34-.136.518.518,0,0,0,.034-.722,5.178,5.178,0,1,1,7.785-.144A.5.5,0,0,0,348.377,50.44Z",
    transform: "translate(-338.014 -40.027)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcasts);
export default __webpack_public_path__ + "static/media/broadcasts.90a36ff2.svg";
export { ForwardRef as ReactComponent };